import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import {
  IonApp,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  setupIonicReact
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import {earth, waterOutline, analyticsOutline, cloudOutline} from 'ionicons/icons';
import { useTranslation } from 'react-i18next';
import Globe from "./pages/globe/Globe";
import Dashboard1 from './pages/dashboards/Dashboard1';
import Dashboard2 from './pages/dashboards/Dashboard2';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import Dashboard3 from "./pages/dashboards/Dashboard3";

setupIonicReact();

const App: React.FC = () => {
  const { t } = useTranslation();

  return (
    <IonApp>
      <IonReactRouter basename={'/webapp'}>
        <IonTabs>
          <IonRouterOutlet>
            <Route path="/globe" component={Globe} exact={true} />
            <Route path="/dashboard1" component={Dashboard1} exact={true} />
            <Route path="/dashboard2" component={Dashboard2} exact={true} />
            <Route path="/dashboard3" component={Dashboard3} exact={true} />
            <Route path="/" render={() => <Redirect to="/globe" />} exact={true} />
          </IonRouterOutlet>
          <IonTabBar slot="bottom">
            <IonTabButton tab="tab1" href="/globe">
              <IonIcon icon={earth} />
              <IonLabel
                className="ion-text-capitalize ion-text-center"
              >
                {t("default:globe")}
              </IonLabel>
            </IonTabButton>
            <IonTabButton tab="dashboard1" href="/dashboard1">
            <IonIcon icon={cloudOutline} />
              <IonLabel
                className="ion-text-capitalize ion-text-center"
              >
                {t("default:bilbao.dashboard1")}
              </IonLabel>
            </IonTabButton>
            <IonTabButton tab="dashboard2" href="/dashboard2">
              <IonIcon icon={analyticsOutline} />
              <IonLabel
                  className="ion-text-capitalize ion-text-center"
              >
                {t("default:bilbao.dashboard2")}
              </IonLabel>
            </IonTabButton>
            <IonTabButton tab="dashboard3" href="/dashboard3">
              <IonIcon icon={waterOutline} />
              <IonLabel
                  className="ion-text-capitalize ion-text-center"
              >
                {t("default:bilbao.dashboard3")}
              </IonLabel>
            </IonTabButton>
          </IonTabBar>
        </IonTabs>
      </IonReactRouter>
    </IonApp>
  );
}

export default App;
